import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CouponRequestStateService } from '@services/coupon-request-state.service';
import { injectParams } from 'ngxtension/inject-params';

@Component({
  selector: 'app-terminal-entry',
  template: '',
})
export class TerminalEntryComponent implements OnInit {
  private token = injectParams('token');
  private router = inject(Router);

  ngOnInit() {
    if (!this.token()) {
      this.router.navigate([CouponRequestStateService.ERRORED_LINK_ROUTE]);
    } else {
      this.router.navigate(['/terminal/', this.token()]);
    }
  }
}
